import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { getCurrentVersion } from './utils/versionChecker';
import { PostHogProvider } from 'posthog-js/react';

// Load version.json first so currentVersion is set before any module (i18n, useTileRenderer)
// uses addCacheBusting(). Otherwise we get Date.now() fallbacks and fragmented cache.
async function bootstrap() {
  await getCurrentVersion();
  const { default: App } = await import('./App');
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
  const app = <App />;

  root.render(
    <React.StrictMode>
      {posthogKey ? (
        <PostHogProvider
          apiKey={posthogKey}
          options={{
            api_host: process.env.REACT_APP_POSTHOG_HOST ?? 'https://us.i.posthog.com',
            ui_host: process.env.REACT_APP_POSTHOG_UI_HOST ?? undefined,
            defaults: '2025-05-24',
            capture_exceptions: true,
            debug: process.env.NODE_ENV === 'development',
            // Avoid blocking the UI when PostHog is unreachable (e.g. HK/China users, slow networks):
            // - Skip the /flags request on init (we only use capture(), not feature flags/session recording).
            advanced_disable_flags: true,
            // Timeout for any flag/decide requests (if flags are re-enabled later).
            feature_flag_request_timeout_ms: 3000,
          }}
        >
          {app}
        </PostHogProvider>
      ) : (
        app
      )}
    </React.StrictMode>
  );
}

bootstrap();